import { TIMEZONE } from '../constants/defaultTimezone';

const convertTZ = (date) => {
  return new Date((typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: TIMEZONE }));
};

export default convertTZ;
